module.exports = new __parcel__URL__("jsm-alerts.eb48cb8d.svg").toString();